import {Spinner} from "@/components/ui/Spinner.tsx";
import {CheckCircleIcon, XCircleIcon} from "@heroicons/react/24/solid";

export type AddressCheckState = {
    isChecking?: boolean | null;
    isServiced?: boolean | null;
    additionalCharge?: string | null;
    error?: string | null;
}

export function AddressChecker({ state }: { state: AddressCheckState | null }) {
    return (
        <>
            {state?.isChecking && (
                <div className={'os-flex os-flex-row os-gap-1 os-items-center'}>
                    <Spinner className="os-h-5 os-w-5 os-text-black"/>
                    Checking address...
                </div>
            )}
            {state?.isServiced && state?.additionalCharge == null && (
                <div className={'os-flex os-flex-row os-gap-1 os-items-center'}>
                    <CheckCircleIcon className="os-h-5 os-w-5 os-text-green-500"/>
                    Address is serviced.
                </div>
            )}
            {state?.isServiced && state?.additionalCharge != null && (
                <div className={'os-flex os-flex-row os-gap-1 os-items-center'}>
                    <CheckCircleIcon className="os-h-5 os-w-5 os-text-green-500"/>
                    This address is outside of standard service area. An additional charge of {state.additionalCharge} applies.
                </div>
            )}
            {state?.error && (
                <div className={'os-flex os-flex-row os-gap-1 os-items-center'}>
                    <XCircleIcon className="os-h-5 os-w-5 os-text-red-500"/>
                    {state?.error ?? 'An error occurred while validating your address. Please try again later or call for a booking'}
                </div>
            )}
        </>
    );
}